import React, { useState } from "react";
import { useNavigate,useHistory  } from "react-router-dom";
import { generatePath } from "react-router";
import {apiUrl, domainUrl} from '../constant';
import {authtoken} from '../global.js';
import {authHeader,authToken} from '../helpers/auth-header';
import axios from 'axios';
const axios1 = require("axios");



export const adminService = {
    addproject,
    gettimesheet,
    getSingletimesheet,
    getteammembers,
    getallclient,
    getallsubclient,
    gettasks,
    selusrtms,
    getproject,
    addtask,
    addbudgethours,
    getbudgethours,
    addrolename,
    getrole,
    getadminrole,
    adddepartment,
    addteam,
    getteam,
    getdepartment, 
    getallsubclienttemp,
    getprojectbyclient,
    getbudgethourstemp,
    getpermission,
    updatepermission,
    updaterole,
    getuserspermission,
    addapilisting,
    getapilisting,
    getapitriggers,
    runapitrigger,
    cancelapitrigger,
    deleteapilisting,
};


function addproject({project}){
    const projectname = project;
    const requestQuery = {projname: projectname};
    return axios({
        method: "post",
        url: `${apiUrl}/api/addproject`,
        data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
           
           if(response.status == 200){
            // console.log("response");
            // console.log(response);
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        }); 
}


function getproject(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getproject`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function addrolename({role}){
  const requestQuery = role;
  return axios({
      method: "post",
      url: `${apiUrl}/api/addrolename`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          console.log("response");
          console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });  
}

function getrole(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getrolename`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function adddepartment({dept}){
  const requestQuery = dept;
  return axios({
      method: "post",
      url: `${apiUrl}/api/adddeptname`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          console.log("response");
          console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
  
}

function getdepartment(){
  // const requestQuery = dept;
  return axios({
    method: "get",
    url: `${apiUrl}/api/getdepartment`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
  
}

function addteam({team}){
  const requestQuery = team;
  return axios({
      method: "post",
      url: `${apiUrl}/api/addteamname`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          console.log("response");
          console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getteam(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getteam`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function addtask({tasks}){
  const requestQuery = tasks;
  return axios({
      method: "post",
      url: `${apiUrl}/api/addtask`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          console.log("response");
          console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}


function gettimesheet({month,member}){
    // bodyFormData.append("email", email);
    // bodyFormData.append("password", password);
    // const userAuthdata = {"email":email,"password":password};
    const _month = month;
    const _member = member;
    const requestQuery = {selectedmnths: _month, selectedmember: _member};
    return axios({
        method: "post",
        url: `${apiUrl}/api/gettimesheetstatusmnth`,
        data: requestQuery,
        headers: {Authorization: `Bearer ${authToken()}` },
      })
        .then(function (response) {
            console.log("response");
            console.log(response);
           if(response.status == 200){
            // console.log("response");
            // console.log(response);
          }
          return response;
        }, error => {
          return error.response;
          // console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        }); 
}


function getSingletimesheet({date,user}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/gettimesheetsingle?date=${date}&&user=${user}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
              
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getteammembers({managerid}){
  let selectedmanagerid = managerid;
  return axios({
      method: "get",
      url: `${apiUrl}/api/getteammembers?managerid=${selectedmanagerid}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          // console.log("response");
          // console.log(response);
         if(response.status == 200){
              
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallclient(){
  return axios({
      method: "get",
      url: `${apiUrl}/api/allclients`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}



function getprojectbyclient({client}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/getprojectbyclient?client=${client}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallsubclient({client}){
  return axios({
      method: "get",
      url: `${apiUrl}/api/allsubclients?client=${client}`,
      // data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function getallsubclienttemp({client}){
  let obj = {'client':client};
  return axios({
      method: "post",
      url: `${apiUrl}/api/allsubclientstemp`,
      data: obj,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
         if(response.status == 200){
                  
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      }); 
}

function gettasks(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/gettasks`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    }); 
}

function selusrtms({obj}){
  
  let tsdate = obj.date;
  let teamsid = obj.userid; 
  return axios({
    method: "get",
    url: `${apiUrl}/api/selusrtms?tsdate=${tsdate}&&teamsid=${teamsid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function addbudgethours({obj}){
  const requestQuery = obj;
  return axios({
      method: "post",
      url: `${apiUrl}/api/addbudgethours`,
      data: requestQuery,
      headers: {Authorization: `Bearer ${authToken()}` },
    })
      .then(function (response) {
          console.log("response");
          console.log(response);
         if(response.status == 200){
          // console.log("response");
          // console.log(response);
        }
        return response;
      }, error => {
        return error.response;
        // console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });
}

function getbudgethours(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getbudgethours`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function getbudgethourstemp({formdata}){
  
  return axios({
    method: "post",
    url: `${apiUrl}/api/getbudgethourstemp`,
    data: formdata,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
       if(response.status == 200){
                
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });  
}

function getpermission(){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getpermission`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function updatepermission({formdata}){
  let requestQuery = formdata;
  return axios({
    method: "post",
    url: `${apiUrl}/api/updatepermission`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function updaterole({formdata}){
  let requestQuery = {'data':formdata};
  return axios({
    method: "post",
    url: `${apiUrl}/api/updaterole`,
    data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getadminrole({userid}){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getadminrole?userid=${userid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
            
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function getuserspermission(userid){
  return axios({
    method: "get",
    url: `${apiUrl}/api/getuserspermission?userid=${userid}`,
    // data: requestQuery,
    headers: {Authorization: `Bearer ${authToken()}` },
  })
    .then(function (response) {
        // console.log("response");
        // console.log(response);
       if(response.status == 200){
              
      }
      return response;
    }, error => {
      return error.response;
      // console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}

function deleteapilisting(id) {
    return axios({
        method: 'delete',
        url: `${apiUrl}/api/deleteapilisting`,
        data: { id },
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}

function getapilisting() {
    return axios({
        method: 'get',
        url: `${apiUrl}/api/getapilisting`,
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}

function addapilisting({ type, apiuri, software, description, id }) {
    return axios({
        method: 'post',
        url: `${apiUrl}/api/manageapilisting`,
        data: { type, apiuri, software, description, id },
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}


function getapitriggers() {
    return axios({
        method: 'get',
        url: `${apiUrl}/api/apitriggers`,
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}

function cancelapitrigger({ command }) {
    return axios({
        method: 'post',
        url: `${apiUrl}/api/cancelapitrigger`,
        data: { command },
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}

function runapitrigger({ command }) {
    return axios({
        method: 'post',
        url: `${apiUrl}/api/runapitrigger`,
        data: { command },
        headers: { Authorization: `Bearer ${authToken()}` },
    })
        .then(function (response) {
            return response;
        }, error => {
            return error.response;
        })
        .catch(function (error) {
            return error.response;
        });
}
